<template>
  <div>

    <base-header class="pb-6 pb-7 pt-5 pt-md-7 bg-gradient">
      <h2 class="pb-4">Провайдеры</h2>
      <div v-if="success && !message" class="alert alert-success" role="alert">
        <strong>Успешно!</strong> Провайдер успешно обновлён.
      </div>
      <div v-if="success && message" class="alert alert-success" role="alert">
        <strong>Успешно!</strong> {{ message }}
      </div>
      <div v-if="fail" class="alert alert-danger" role="alert">
        <strong>Ошибка!</strong> Проверьте введенные данные.
      </div>
      <!-- Card stats -->
      <b-row>
        <b-col>
          <b-modal :visible.sync="sms" id="modal-otp" title="Подтверждение" @ok="authProviderSms" @hide="sms = false">
            <p>
              {{ message }}
            </p>
            <b-form-group class="text-sm" label="Введите код из СМС" label-for="input-otp">
              <base-input v-model="code" placeholder="Код"></base-input>
            </b-form-group>
            <template v-slot:modal-ok>
              <span>Подтвердить</span>
            </template>
            <template v-slot:modal-cancel>
              <span>Отмена</span>
            </template>
          </b-modal>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="provider in providers" xl="3" md="6" class="mb-4">
          <div class="card bg-secondary shadow">
            <div class="card-header bg-white border-0">
              <div class="row align-items-center">
                <div class="col-6">
                  <h3 class="mb-0">{{ provider.type }}</h3>
                </div>
                <div class="col-6 text-right">
                  <button @click="updateProviderStatus(provider)" type="button" class="btn btn-sm" :class="{ 'btn-success': provider.is_active, 'btn-danger': !provider.is_active }">
                    <span v-if="provider.is_active">
                      Активен
                    </span>
                    <span v-if="!provider.is_active">
                      Не активен
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <form>
                <h6 class="heading-small text-muted mb-4">Данные для авторизации</h6>
                <div class="pl-lg-0">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group focused">
                        <label class="form-control-label" for="input-username">Логин</label>
                        <input autocomplete="false" type="text" id="input-username" class="form-control form-control-alternative"
                               placeholder="Логин" v-model="provider.login">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group focused">
                        <label class="form-control-label" for="input-first-name">Пароль</label>
                        <input autocomplete="false" type="password" id="input-first-name" class="form-control form-control-alternative"
                               placeholder="Пароль" v-model="provider.password">
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="text-right mr-4 mb-4">
              <button type="button" @click="updateProvider(provider)"
                      class="btn btn-primary my-2">Обновить
              </button>
              <button type="button" @click="authProvider(provider)"
                      class="btn btn-primary my-2" :class="{ disabled: !provider.is_authable }">Авторизовать
              </button>
            </div>
          </div>
        </b-col>
      </b-row>
    </base-header>
  </div>
</template>

<script>

// Components

import Modal from "@/components/Modal.vue";
import axios from "axios"

export default {
  components: {
    Modal
  },
  data() {
    return {
      providers: [],
      success: false,
      fail: false,
      sms: false,
      message: null,
      code: '',
      current_provider: null
    };
  },
  methods: {
    async getProviders() {
      const response = await axios.get('dashboard/providers')
      this.providers = response.data.providers
    },
    async updateProvider($provider) {
      let res;
      try {
        res = await axios.post("dashboard/providers", {
          id: $provider.id,
          login: $provider.login,
          password: $provider.password,
          type: $provider.type
        })
      } catch (e) {
        if (e.response.status === 401) {
          await this.$router.push({name: 'login'});
        }

        this.fail = true;
        setTimeout(() => this.fail = false, 5000);

        console.log(e);
      }

      if (res.data.status === true) {
        this.success = true;
        setTimeout(() => this.success = false, 5000);
      }
    },
    async authProvider($provider) {
      let res;
      if (!$provider.is_authable) return;
      try {
        res = await axios.post("dashboard/providers/auth", {
          id: $provider.id,
          type: $provider.type
        })
      } catch (e) {
        if (e.response.status === 401) {
          await this.$router.push({name: 'login'});
        }

        this.fail = true;
        setTimeout(() => this.fail = false, 5000);

        console.log(e);
      }

      if (res.data.status === true) {
        if (res.data.message !== null) {
          this.success = true;
          this.message = res.data.message;
            setTimeout(() => this.success = false, 5000);
        } else {
          this.sms = true;
          this.message = "Код отправлен на номер " + res.data.phone + ". Введите код для авторизации в течение " + res.data.expire + " секунд";
          this.current_provider = $provider;
        }
      }
    },
    async authProviderSms() {
      let res;
      if (!this.current_provider.is_authable) return;
      try {
        res = await axios.post("dashboard/providers/auth/sms", {
          id: this.current_provider.id,
          code: this.code
        })
      } catch (e) {
        if (e.response.status === 401) {
          await this.$router.push({name: 'login'});
        }

        this.fail = true;
        setTimeout(() => this.fail = false, 5000);

        console.log(e);
      }

      if (res.data.status === true) {
        this.sms = false;
        this.success = true;
        this.message = "Успешно авторизован";
        setTimeout(() => this.success = false, 5000);
      }
    },
    async updateProviderStatus($provider) {
      let res;
      try {
        res = await axios.post("dashboard/providers", {
          id: $provider.id,
          is_active: !$provider.is_active,
          type: $provider.type
        })
      } catch (e) {
        if (e.response.status === 401) {
          await this.$router.push({name: 'login'});
        }
        console.log(e);
      }

      if (res.data.status === true) {
        $provider.is_active = !$provider.is_active;
      }
    }
  },
  mounted() {
    this.getProviders();
  }
};
</script>
<style>
h2 {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
}

.el-table .cell {
  padding-left: 0;
  padding-right: 0;
}

.bg-gradient {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important
}
</style>
